import * as React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import HashTags from "../components/HashTags"
import AmosovaLeftBanner from "../components/ads/AmosovaLeftBanner"
import AmosovaBigTopBanner from "../components/ads/AmosovaBigTopBanner"

const TagTemplate = ({ data }) => {
  var themeTextColor = "text-fb-blue"
  return (
    <Layout>
      <Seo title="Tag" />
      {data.sanityAdBanner.positionsOtherPages.topBar && (
        <AmosovaBigTopBanner />
      )}
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-4">
          <div className="col-span-4 md:col-span-4 lg:col-span-3 p-5">
            <h2 className="text-fb-blue font-semibold subcategory">
              #{data.sanityTag.title}
            </h2>
            <hr />
            <p className="py-3 font-roboto text-base text-gray-800">
              {data.sanityTag.description}
            </p>
            <span className="text-md font-robototext-md font-normal font-roboto">
              Количество статей: <b>{data.allSanityPost.totalCount}</b>
            </span>
            <div className="divide-y divide-gray-300">
              {data.allSanityPost.nodes.map(post => {
                switch (post.categories.color) {
                  case "fb-green": {
                    themeTextColor = "text-fb-green"
                    break
                  }
                  case "fb-turquoise": {
                    themeTextColor = "text-fb-turquoise"
                    break
                  }
                  case "fb-gray": {
                    themeTextColor = "text-fb-gray"
                    break
                  }
                  case "fb-red": {
                    themeTextColor = "text-fb-red"
                    break
                  }
                  case "fb-violet": {
                    themeTextColor = "text-fb-violet"
                    break
                  }
                  default: {
                    themeTextColor = "text-fb-blue"
                    break
                  }
                }
                return (
                  <div key={post.id}>
                    <div className="px-5 py-3 bg-opacity-10 bg-transparent hover:bg-fb-blue hover:bg-opacity-10">
                      <Link
                        to={`/${post.categories.slug.current}/${post.slug.current}`}
                      >
                        <span className="text-fb-blue hover:underline text-2xl font-semibold font-opensanscond">
                          {post.title}
                        </span>
                      </Link>
                      <div className="flex justify-between">
                        <div className="text-fb-blue text-sm font-normal font-roboto">
                          <Link to={`/${post.categories.slug.current}`}>
                            <span
                              className={`font-semibold hover:underline ${themeTextColor}`}
                            >
                              {post.categories.title}
                            </span>
                          </Link>
                          <span className="px-2">&#183;</span>
                          <span>{post.subcategory}</span>

                          <p className="text-xs">
                            <span>{post.author.name}</span>
                            <span className="px-2">&#183;</span>
                            {post.publishedAt}
                          </p>
                        </div>
                        <div>
                          {post.tags.map((tag, index) => (
                            <Link
                              key={index}
                              to={`/tags/${tag.slug.current}`}
                              className="hover:underline"
                            >
                              <small
                                className={
                                  `mr-2 ` +
                                  (data.sanityTag.slug.current ===
                                    tag.slug.current &&
                                    `bg-yellow-200 rounded p-1`)
                                }
                              >
                                #{tag.title}
                              </small>
                            </Link>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="col-span-4 md:col-span-4 lg:col-span-1">
            <div className="bg-fb-blue bg-opacity-10">
              {data.sanityAdBanner.positionsOtherPages.leftBar && (
                <AmosovaLeftBanner />
              )}
            </div>
            <HashTags />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($pathSlug: String!) {
    allSanityPost(
      filter: { tags: { elemMatch: { slug: { current: { eq: $pathSlug } } } } }
      sort: { fields: publishedAt, order: DESC }
    ) {
      nodes {
        title
        subcategory
        publishedAt(formatString: "DD-MM-YYYY")
        dedicated
        categories {
          title
          slug {
            current
          }
          color
        }
        author {
          name
        }
        slug {
          current
        }
        id
        tags {
          title
          slug {
            current
          }
        }
      }
      totalCount
    }
    sanityTag(slug: { current: { eq: $pathSlug } }) {
      title
      description
      slug {
        current
      }
    }
    sanityAdBanner(id: { eq: "-6025e2e7-5795-581f-97b5-7436c86dbe7b" }) {
      positionsOtherPages {
        topBar
        leftBar
      }
    }
  }
`
export default TagTemplate
